import api from './api';

const messageService = {
  // Benachrichtigungen
  getNotifications: async (unreadOnly = false) => {
    const response = await api.get('/notifications/', { params: { unread_only: unreadOnly } });
    return response.data;
  },
  
  getUnreadNotificationCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },
  
  markNotificationAsRead: async (notificationId) => {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  },
  
  markAllNotificationsAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },
  
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  },
  
  // Konversationen / Direktnachrichten
  getConversations: async () => {
    const response = await api.get('/messages/conversations');
    return response.data;
  },
  
  getMessages: async (conversationId) => {
    const response = await api.get(`/messages/conversations/${conversationId}`);
    return response.data;
  },
  
  sendMessage: async (recipientId, content) => {
    const response = await api.post('/messages/send', {
      recipient_id: recipientId,
      content
    });
    return response.data;
  },
  
  getUnreadMessagesCount: async () => {
    const response = await api.get('/messages/unread-count');
    return response.data;
  },
  
  getAvailableUsers: async () => {
    const response = await api.get('/messages/users');
    return response.data;
  }
};

export default messageService;
